import axios from 'axios';
import router from '@/router';
import store from '@/store';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import sessionService from '@/services/sessionService';
import Vue from 'vue';

const apiPath = `${store.state.apiPathWithVersion}/password`;

export default {
  async login(model) {
    let apiUrl = store.state.countrySelected.api;
    try {
      let respToken = await axios.post(`${apiUrl}/api/login`, model);
      store.commit('UPDATE_TOKEN', respToken.data);

      let respSessionCheck = await sessionService.check(false);

      if (respSessionCheck.error) {
        return respSessionCheck;
      }
      respSessionCheck.data.loginStatus = respToken.status;
      return {
        data: respSessionCheck.data,
        error: false,
      };
    } catch (error) {
      return {
        data: error.status,
        error: true,
      };
    }
  },

  async logout(goTo) {
    if (!goTo) {
      goTo = '/';
    }
    // Clear access token and ID token from local storage
    try {
      await firebase.auth().signOut();
      store.commit('LOGOUT_USER');
      Vue.mam.logout();
      router
        .push({
          path: goTo,
        })
        .catch((_) => {});
    } catch (_) {
      // console.log(error);
    }
  },

  async forgotPassword(params) {
    let apiUrl = store.state.countrySelected.api;
    try {
      let resp = await axios.get(`${apiUrl}/${apiPath}/forgot`, {
        params: params,
      });
      return {
        data: resp.data,
        error: false,
      };
    } catch (error) {
      return {
        status: error.status,
        data: error.data,
        error: true,
      };
    }
  },

  async resetPassword(url, params) {
    let apiUrl = url;
    try {
      let resp = await axios.post(`${apiUrl}/${apiPath}/modify`, params);
      return {
        data: resp.data,
        error: false,
      };
    } catch (error) {
      return {
        status: error.status,
        data: error.data,
        error: true,
      };
    }
  },
};
